import { AccountHolder } from "@tlc/ls2pac/components/Account";
import { TLCEvents } from "../../../../js/lib/events/events";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { eResourceRedirect } from "../../../../js/main/eResourceRedirect";
import { AvailabilityFactory } from "../../availability/AvailabilityFactory";
import { ApplicationData } from "../../ls2pac/ApplicationData";
import { AvailabilityClientManager } from "../../ls2pac/ClientManagers/AvailabilityClientManager";
import { EResourceCheckoutsClientManager } from "../../ls2pac/ClientManagers/EResourceCheckoutsClientManager";
import { LoginClientManager } from "../../ls2pac/ClientManagers/LoginClientManager";
import { RequestsClientManager } from "../../ls2pac/ClientManagers/RequestsClientManager";
import { LS2PAC_Utils } from "../../ls2pac/utils/Utils";
import { ResourceUtils } from "../../ls2pac/utils/resourceUtils";
import { LS2KIDS_CONSTANTS } from "../constants";
import { KidsMessaging } from "../messaging";

export class KidsHoldsView {
  constructor() {
    this.addEventListeners();
  }
  addEventListeners() {
    TLCEvents.on(
      LS2KIDS_CONSTANTS.Events.onPromptToHoldResource,
      this.onPromptToHoldResource,
      this
    );
    TLCEvents.on(LS2PAC_CONSTANTS.Events.onCloseLogin, this.onCloseLogin, this);
    TLCEvents.on(
      LS2PAC_CONSTANTS.Events.onRequestResponse,
      this.onRequestResponse,
      this
    );
    TLCEvents.on(
      LS2PAC_CONSTANTS.Events.onEResourcePlaceHoldResponse,
      this.onEResourcePlaceHoldResponse,
      this
    );
    TLCEvents.on(
      EResourceCheckoutsClientManager.checkoutEventResponse,
      this.onEResourceCheckoutResponse,
      this
    );
  }
  doEResourceCheckout(resource) {
    var _this = this;
    this._currentResource = resource;
    if (resource.eResourceFormats.length > 0) {
      if (resource.eResourceService === "overdrive") {
        _this.doEResourceCheckoutForOverdrive(resource);
      } else {
        _this.doEResourceCheckoutNotOverdrive(resource);
      }
    } else {
      throw "There was no format length during the checkout process...";
    }
  }
  doEResourceCheckoutForOverdrive(resource) {
    var message = "<span>";
    message += ApplicationData.language.kidseResourceFormatsAvailable.replace(
      "%TITLE%",
      resource.shortTitle
    );
    message += "</span>";
    for (var i = 0, len = resource.eResourceFormats.length; i < len; i += 1) {
      message += "<dd>" + resource.eResourceFormats[i].formatName + "</dd>";
    }

    KidsMessaging.confirm({
      message: message,
      successButton: ApplicationData.language.kidsLoginButton,
      failButton: ApplicationData.language.kidsForgetIt,
      successCallback: function () {
        TLCEvents.trigger(EResourceCheckoutsClientManager.checkoutEvent, {
          resource: resource,
        });

        KidsMessaging.showDelayed(
          ApplicationData.language.kidsWaitForResponse,
          1000
        );
      },
    });
  }
  doEResourceCheckoutNotOverdrive(resource) {
    var buttons = [];

    for (var i = 0, len = resource.eResourceFormats.length; i < len; i += 1) {
      var format = resource.eResourceFormats[i];

      buttons.push({
        label: format.formatName,
        id: format.formatId,
      });
    }

    KidsMessaging.confirm({
      message:
        "Select your format for" + " <span>" + resource.shortTitle + "</span>",
      buttons: buttons,
      failButton: ApplicationData.language.kidsForgetIt,
      wrapperCustomClass: "ebook-format-selection-buttons",
      successCallback: function (id) {
        TLCEvents.trigger(EResourceCheckoutsClientManager.checkoutEvent, {
          resource: resource,
          format: id,
        });

        KidsMessaging.showDelayed(
          ApplicationData.language.kidsWaitForResponse,
          1000
        );
      },
    });
  }
  refreshAvailability(resource, forceCheckout) {
    forceCheckout = forceCheckout || false;

    var _this = this;

    AvailabilityClientManager.getItemAvailability(
      [resource],
      function (newResources) {
        setTimeout(function () {
          resource = newResources[0];

          AvailabilityFactory.getDisplayObject(resource);

          var invalidUser = false;

          if (resource.eAvailabilities && resource.eAvailabilities.length > 0) {
            for (
              var i = 0, len = resource.eAvailabilities.length;
              i < len;
              i += 1
            ) {
              var availability = resource.eAvailabilities[i];

              if (availability.invalidUser) {
                var availabilityToken =
                  ResourceUtils.getTokenFromEAvailability(availability);

                let message =
                  ResourceUtils.getKidsMessageForScout(availabilityToken);

                KidsMessaging.showThenHide(message, 15000);

                invalidUser = true;
                break;
              }
            }
          }

          if (invalidUser) {
            return;
          }

          if (resource.downloadable) {
            if (resource.availability || forceCheckout) {
              if (
                resource.eResourceFormats &&
                resource.eResourceFormats.length > 0
              ) {
                _this.doEResourceCheckout(resource);
              } else {
                let message = ResourceUtils.getKidsMessageForScout(
                  "eResourceNoFormatsMessage"
                );
                KidsMessaging.show(message, 15000);
              }
            } else {
              _this.doEResourceHold(resource);
            }
          }
        }, 1000);
      },
      false,
      false
    );
  }
  doHold(resource) {
    if (LS2PAC_Utils.isValidPatronIdUser(ApplicationData.getCurrentUser())) {
      KidsMessaging.showDelayed(
        ApplicationData.language.kidsWaitForResponse,
        1000
      );
      if (resource.downloadable) {
        if (resource.eResourceFormats && resource.eResourceFormats.length > 0) {
          if (resource.availability) {
            this.doEResourceCheckout(resource);
          } else {
            this.doEResourceHold(resource);
          }
        } else {
          this.refreshAvailability(resource);
        }
      } else {
        TLCEvents.trigger(RequestsClientManager.submitRequestEvent, {
          data: [resource],
          pickupBranchId: ApplicationData.getUserDefaultPickupBranch(),
          isTitleLevel: true,
        });
      }
    }
  }
  doEResourceHold(resource) {
    this._currentResource = resource;

    TLCEvents.trigger(EResourceCheckoutsClientManager.placeHoldEvent, {
      resource: resource,
    });
  }
  onRequestResponse(event) {
    const holdInfo = event.data.placeHoldInfos[0];
    const messageToken = ResourceUtils.getMessageToken(holdInfo.message);
    const message = holdInfo.success
      ? ResourceUtils.getKidsMessageForScout(messageToken, { headline: 0 })
      : ResourceUtils.getKidsMessageForScout(messageToken, holdInfo);

    KidsMessaging.showThenHide(message, 5000);
  }
  _youDidItMessage(messageToken) {
    var message = ResourceUtils.getKidsMessageForScout(
      "YouDidIt",
      messageToken,
      { headline: 0 }
    );

    KidsMessaging.showThenHide(message, 5000);
  }
  allowDownloadNow() {
    return (
      !ApplicationData.locationConfiguration.isStationLocationSet() ||
      ApplicationData.locationConfiguration.isKidsOverrideDownloadNowStationLocation()
    );
  }
  onEResourceCheckoutResponse(event) {
    if (event.success) {
      if (event.autoSync) {
        this._youDidItMessage("eResourcePushableMessage");
      } else {
        if (this.allowDownloadNow()) {
          if (event.service === "overdrive") {
            KidsMessaging.confirm({
              message: ResourceUtils.getKidsMessageForScout(
                "eResourceSuccessToken",
                "eResourceNowOrLater",
                { headline: 1 }
              ),
              successButton: ApplicationData.language.kidseResourceNow,
              failButton: ApplicationData.language.kidseResourceLater,
              failCallback: function () {
                var message = ResourceUtils.getKidsMessageForScout(
                  "eResourceAskLibrarianWhenReady"
                );
                KidsMessaging.showThenHide(message, 5000);
              },
              successCallback: function () {
                KidsMessaging.showOverdriveFulfillmentInterface({
                  overDriveUrl: eResourceRedirect(
                    event.itemId,
                    event.service
                  ),
                  failButton: ApplicationData.language.kidsForgetIt,
                });
              },
            });
          } else {
            KidsMessaging.confirm({
              message: ResourceUtils.getKidsMessageForScout(
                "eResourceSuccessToken",
                "eResourceNowOrLater",
                { headline: 1 }
              ),
              successButton: ApplicationData.language.kidseResourceNow,
              failButton: ApplicationData.language.kidseResourceLater,
              successButtonTarget: "_blank",
              successButtonHref: eResourceRedirect(
                event.itemId,
                event.service
              ),
              failCallback: function () {
                var message = ResourceUtils.getKidsMessageForScout(
                  "eResourceAskLibrarianWhenReady"
                );
                KidsMessaging.showThenHide(message, 5000);
              },
            });
          }
        } else {
          KidsMessaging.show(
            ResourceUtils.getKidsMessageForScout(
              "eResourceSuccessDownloadBlocked"
            )
          );
        }
      }
    } else {
      var messageToken = ResourceUtils.getTokenFromEAvailability(event);
      var message = ResourceUtils.getKidsMessageForScout(messageToken);

      KidsMessaging.showThenHide(message, 15000);
    }

    this._currentResource = null;
  }
  onEResourcePlaceHoldResponse(event) {
    //	var _this = this;
    var options = {};
    var token = ResourceUtils.getMessageToken(event.message);

    if (event.success) {
      options.headline = 0;
    }

    if (event.checkedOut) {
      token = "TitleAlreadyCheckedOutToken";
    }

    var message = ResourceUtils.getKidsMessageForScout(token, options);

    //	if( token == "placeHoldOnArrivedHoldErrorMessage" ) {
    //		LS2KidsMessaging.confirm( {
    //			message:         ResourceUtils.getKidsMessageForScout( token, {headline: 1} ),
    //			successButton:   ApplicationData.language.yes,
    //			failButton:      ApplicationData.language.no,
    //			successCallback: function () {
    //				_this.refreshAvailability( _this._currentResource, true );
    //			}
    //		} );
    //	} else {
    KidsMessaging.showThenHide(message, 15000);

    this._currentResource = null;
    //	}
  }
  onCloseLogin(event) {
    if (this._waitingToLogin && ApplicationData.getCurrentUser() != null) {
      this.doHold(this._currentResource);
      this._currentResource = null;
    }
  }
  onPromptToHoldResource(data) {
    var _this = this;

    var resource = data.resource;
    var available = data.available;

    //	if( resource.downloadable ) { return; }
    function placeOnHold(message) {
      KidsMessaging.confirm({
        message: message + "<span>" + resource.shortTitle + "</span>",
        successButton: ApplicationData.language.yes,
        failButton: ApplicationData.language.no,
        successCallback: async function () {
          
          const {isAuthenticated} = await AccountHolder.fetchAccountData();
          if(isAuthenticated){
            _this.doHold(resource);
          }
          else {
            _this._currentResource = resource;
            TLCEvents.trigger(LS2PAC_CONSTANTS.Events.onPromptForLogin);
            _this._waitingToLogin = true;

            KidsMessaging.show(
              ApplicationData.language.kidsLoginIfYouWantIt
            );
          }
        },
      });
    }

    var currentUser = ApplicationData.getCurrentUser();
    if (data.askLibrarianForHelp) {
      KidsMessaging.show(
        "<span>" + ApplicationData.language.kidsAskForHelpEResource + "</span>"
      );
    } else if (
      currentUser == null ||
      LS2PAC_Utils.isValidPatronIdUser(currentUser)
    ) {
      if (available) {
        if (
          ApplicationData.locationConfiguration.getAllowHolds().onShelf ||
          data.resource.downloadable
        ) {
          if (data.resource.downloadable) {
            placeOnHold(
              '<span class="headline">' +
                ApplicationData.language.kidsWouldYouLikeToSaveEBook +
                "</span>"
            );
          } else {
            placeOnHold(
              '<span class="headline">' +
                ApplicationData.language.kidsWouldYouLikeToSave +
                "</span>"
            );
          }
        } else {
          KidsMessaging.show(
            "<span>" +
              ApplicationData.language.kidsResourceAvailable +
              "</span>" +
              "<span>" +
              ApplicationData.language.kidsAskForHelp +
              "</span>"
          );
        }
      } else if (
        (resource.eAvailabilities && resource.eAvailabilities.length > 0) ||
        resource.holdingsInformations.length > 0
      ) {
        placeOnHold(
          "<span>" +
            ApplicationData.language.kidsAlreadyCheckedOut +
            "</span>" +
            '<span class="headline">' +
            ApplicationData.language.kidsWantWhenCheckedIn +
            "</span>"
        );
      }
    }
  }
}
